const formatPrice = (value) => new Intl.NumberFormat('es-CO', {
  style: 'currency',
  currency: 'COP',
  maximumFractionDigits: 0
}).format(Number(value || 0))

export default function PublicCatalogProductModal({
  isOpen,
  productData,
  selectedVideoId,
  selectedQuantity,
  totalCartQuantity,
  onClose,
  onSelectVideo,
  onDecreaseQuantity,
  onIncreaseQuantity,
  onAddToCart,
  onToggleCart
}) {
  if (!isOpen || !productData) {
    return null
  }

  const selectedVideo = productData.product.videos.find((video) => video.id === selectedVideoId) || productData.product.videos[0] || null
  const isTikTok = String(selectedVideo?.sourceType || '').toLowerCase() === 'tiktok'
  const mediaFrameClass = isTikTok
    ? 'w-full max-w-[360px] mx-auto h-[min(62vh,640px)] rounded-2xl border-0 bg-black block'
    : 'w-full h-[min(46vh,460px)] rounded-2xl border-0 bg-black block'
  const modalGridClass = isTikTok
    ? 'w-full max-w-6xl max-h-[92vh] overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-2xl grid lg:grid-cols-[minmax(0,420px)_minmax(0,1fr)]'
    : 'w-full max-w-5xl max-h-[90vh] overflow-hidden rounded-[28px] border border-slate-200 bg-white shadow-2xl grid lg:grid-cols-[minmax(0,1fr)_380px]'

  return (
    <div className="fixed inset-0 z-40 bg-slate-950/60 backdrop-blur-[2px] grid place-items-center p-4" onClick={onClose}>
      <div
        className={modalGridClass}
        onClick={(event) => event.stopPropagation()}
      >
        <section className="bg-slate-950 text-white grid grid-rows-[auto_auto] min-h-0">
          <div className="p-3 flex justify-center">
            {selectedVideo ? (
              <iframe
                src={selectedVideo.embedUrl || selectedVideo.videoUrl}
                loading="lazy"
                title={selectedVideo.title}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
                className={mediaFrameClass}
              />
            ) : (
              <div className="min-h-[260px] grid place-items-center text-slate-300">Este producto no tiene videos publicados.</div>
            )}
          </div>

          <div className="grid [grid-template-columns:repeat(auto-fit,minmax(110px,1fr))] gap-2 px-3 pb-3 overflow-auto">
            {productData.product.videos.map((video) => (
              <button
                key={video.id}
                type="button"
                onClick={() => onSelectVideo(video.id)}
                className={`text-left rounded-2xl px-3 py-2 border transition-colors ${selectedVideo?.id === video.id ? 'border-blue-300 bg-blue-900/20 text-white' : 'border-white/10 bg-white/5 text-white'}`}
              >
                <div className="text-[13px] font-bold leading-tight line-clamp-2">{video.title}</div>
                <div className="mt-1 text-[11px] opacity-75">{video.sourceType}</div>
              </button>
            ))}
          </div>
        </section>

        <aside className="min-h-0 overflow-auto bg-white">
          <div className="p-5 grid gap-4">
            <div className="flex items-start justify-between gap-3">
              <div className="grid gap-1">
                <div className="uppercase tracking-[0.18em] text-[11px] text-slate-500">Producto</div>
                <h2 className="text-[clamp(22px,2.4vw,32px)] leading-tight tracking-tight text-slate-900">
                  {productData.product.name}
                </h2>
              </div>
              <button
                type="button"
                onClick={onClose}
                className="w-10 h-10 rounded-full bg-slate-100 text-slate-700 text-lg font-bold shrink-0"
              >
                x
              </button>
            </div>

            {productData.product.categoryName && (
              <div className="inline-flex items-center w-fit rounded-full px-3 py-1 bg-slate-100 text-slate-600 text-xs font-bold">
                {productData.product.categoryName}
              </div>
            )}

            <p className="text-sm leading-6 text-slate-500">
              {productData.product.description || 'Explora el video y revisa la presentacion completa del producto.'}
            </p>

            <div className="text-3xl font-semibold text-slate-900">
              {formatPrice(productData.product.price)}
            </div>

            <div className="flex items-center gap-3 flex-wrap">
              <div className="inline-flex items-center gap-2 border border-slate-200 rounded-full p-1 bg-white">
                <button type="button" className="w-8 h-8 rounded-full bg-slate-100 font-bold" onClick={onDecreaseQuantity}>
                  -
                </button>
                <span className="min-w-6 text-center text-sm font-bold">{selectedQuantity}</span>
                <button type="button" className="w-8 h-8 rounded-full bg-slate-100 font-bold" onClick={onIncreaseQuantity}>
                  +
                </button>
              </div>
              <button type="button" className="inline-flex items-center justify-center min-h-10 px-4 rounded-full bg-blue-600 text-white text-sm font-bold" onClick={onAddToCart}>
                Agregar al carrito
              </button>
              <button type="button" className="inline-flex items-center justify-center min-h-10 px-4 rounded-full border border-slate-200 bg-white text-slate-700 text-sm font-bold" onClick={onToggleCart}>
                {totalCartQuantity} en carrito
              </button>
            </div>

            <div className="grid gap-2">
              <div className="uppercase tracking-[0.12em] text-[13px] text-slate-500">Negocio</div>
              <div className="text-base text-slate-900">{productData.profile.displayName || productData.profile.businessName}</div>
              <div className="text-sm leading-6 text-slate-500">{productData.profile.tagline || productData.profile.description || ''}</div>
            </div>

            <div className="border-t border-slate-200 pt-4 whitespace-pre-wrap text-sm leading-6 text-slate-700">
              {productData.product.presentation || productData.product.description || 'Sin presentacion adicional.'}
            </div>
          </div>
        </aside>
      </div>
    </div>
  )
}
